import axios from '@/axios/globalaxios'

// 搜索服务
export const giveServiceTo = data =>{
  return axios({
      url: "/tradelab/search/reportList",
      method: 'get',
			params:data
  })
}